// extracted by mini-css-extract-plugin
export default {"cell":"delivery_cell__MAykC","active":"delivery_active__+FzXb","inactive":"delivery_inactive__kBdZJ","textCenter":"delivery_textCenter__7zCN8"};